"use server";

import { auth } from "@/auth";
import type { ActionResult } from "@/types/server-action";
import { z } from "zod";
import { validateParams } from "@/lib/utils";
import type { Draft } from "@/prisma/generated/client";
import { updateDraftAfterStepSave } from "@/lib/cat/draft-step-save";
import {
  buildDraftLockHolder,
  DraftLockDeniedError,
} from "@/lib/cat/draft-lock";

const saveDraftDataSchema = z.object({
  id: z.number(),
  signatureDate: z.date(),
  preferredDeliveryDate: z.date(),
  maxDeliveryDate: z.date(),
  salesPersonId: z.number().nullable(),
  partnerOffersRefusal: z.boolean(),
  vgfOffersConsent: z.boolean(),
});

export async function saveDraftData(
  params: z.infer<typeof saveDraftDataSchema>,
): Promise<ActionResult<Draft>> {
  try {
    const session = await auth();
    if (!session?.user?.id) {
      return { success: false, message: "Non authentifié." };
    }
    const clientdata = validateParams(saveDraftDataSchema, params);
    const { id, ...data } = clientdata;

    const sessionKvps = session.data?.kvps?.current?.identifier ?? String(id);

    const lockHolder = buildDraftLockHolder(session.user);

    const savedDraft = await updateDraftAfterStepSave({
      draftId: id,
      stepId: "additional_informations",
      userId: lockHolder.userId,
      userName: lockHolder.userName,
      kvps: sessionKvps,
      data,
    });
    return { success: true, data: savedDraft };
  } catch (error) {
    console.error(error);

    if (error instanceof DraftLockDeniedError) {
      return { success: false, message: error.message };
    }

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}
